import React from 'react';
import FooterStyled from '../styles/FooterStyled';

function Footer() {
  return (
    <FooterStyled>
      &copy; {new Date().getFullYear()}
    </FooterStyled>
  );
}

export default Footer;
